import { render, staticRenderFns } from "./ChLoadingSpinner.vue?vue&type=template&id=248448ba&scoped=true"
import script from "./ChLoadingSpinner.vue?vue&type=script&lang=js"
export * from "./ChLoadingSpinner.vue?vue&type=script&lang=js"
import style0 from "./ChLoadingSpinner.vue?vue&type=style&index=0&id=248448ba&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "248448ba",
  null
  
)

export default component.exports